<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="dialogForm"
          @submit.native.prevent
        >
          <el-form-item label="卡牌名称" prop="name">
            <el-input
              v-model="dialogForm.name"
              placeholder="请输入卡牌名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="等级" prop="level">
            <el-select v-model="dialogForm.level" clearable placeholder="请选择卡牌等级">
              <el-option
                v-for="(item, index) in businessList"
                :key="index"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="dialogForm.status" placeholder="请选择卡牌状态">
              <el-option
                v-for="item in statusList"
                :key="item.type"
                :label="item.name"
                :value="item.type"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              size="medium"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
            <el-button
              icon="el-icon-plus"
              native-type="submit"
              size="medium"
              type="primary"
              @click="handleAdd"
            >
              新增
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        row-key="transaction_id"
        border
        stripe
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="卡牌名称"
          prop="name"
          height="500"
        />
        <el-table-column
          align="center"
          label="等级"
          prop="level"
          height="500"
        />
        <el-table-column
          align="center"
          label="创建日期"
          prop="psp_order_id"
          height="500"
        >
          <template #default="{ row }">
            {{ transTime(row.insert_time) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template #default="{ row }">
            <el-button
              type="primary"
              @click="edit(row)"
              size="small"
            >
              <span>编辑</span>
            </el-button>
            <el-button
              type="danger"
              @click="delet(row)"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getCardList, delCard } from '@/api/radio'
import { transTime } from "@/utils/transTime"
export default {
  data() {
    return {
      transTime,
      dialogForm: {
        name: "",
        level: '',
        status: null,
      }, // 模态框展示的数据
      statusList: [
        { name: "上架", type: '1' },
        { name: "下架", type: '0' },
      ],
      queryForm: {
        page: 1,
        pageSize: 10,
      },
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0,
      tableData: [],
      businessList: [],
      series_id: null
    };
  },
  created() {
    this.businessList = JSON.parse(JSON.parse(this.$route.query.row).level_list)
    this.series_id = JSON.parse(this.$route.query.row).id
    this.fetchData()
  },
  mounted() {},

  methods: {
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      // 这里发请求
      let params = {
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
        level: this.dialogForm.level,
        name: this.dialogForm.name,
        series_id: this.series_id ? this.series_id : -1,
        status: this.dialogForm.status ? this.dialogForm.status : -1
      }
      await getCardList(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.data_list
            this.total = res.data.total_record
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    edit(row){
      sessionStorage.setItem('card', JSON.stringify(row))
      sessionStorage.setItem('levels', JSON.stringify(this.businessList))
      this.$router.push({
        path: '/cardAdd',
        query: {
          type: 'edit',
          // levels: JSON.stringify(this.businessList),
          series_id: this.series_id,
          // row: JSON.stringify(row)
        }
      })
    },
    handleAdd(){
      sessionStorage.setItem('levels', JSON.stringify(this.businessList))
      this.$router.push({
        path: '/cardAdd',
        query: {
          type: 'add',
          // levels: JSON.stringify(this.businessList),
          series_id: this.series_id
        }
      })
    },
    delet(row){
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delCard({id: row.id}).then(res => {
          if(res && res.code){
            this.fetchData()
          }
        })
      }).catch(() => {
      })
    },
    handleCurrentChange(){

    },
    handleSizeChange(){

    }
  },
};
</script>
<style lang="scss" scoped>
</style>
